export const ORIGINS = [
  { value: "", label: "Todas as origens" },
  { value: "ML", label: "Mercado Livre" },
  { value: "SHOPEE", label: "Shopee" },
  { value: "CORREIOS", label: "Correios" },
  { value: "OUTROS", label: "Outros" },
];

export const STATUS_FILTERS = [
  { value: "", label: "Todos os status" },
  { value: "PROCESSANDO", label: "Processando" },
  { value: "CONFIRMADO", label: "Confirmado" },
  { value: "REJEITADO", label: "Rejeitado" },
  { value: "DEPOSITADO", label: "Depositado" },
  { value: "RETIRADO", label: "Retirado" },
  { value: "EXPIRADO", label: "Expirado" },
];

// Rótulo do filtro de data conforme o status escolhido — espelha o
// mapeamento de campo no back (PROCESSANDO -> createdAt, CONFIRMADO ->
// confirmedAt, etc.). Sem status, filtra pela data de criação.
export const STATUS_DATE_LABELS = {
  PROCESSANDO: "Data de criação",
  CONFIRMADO: "Data de confirmação",
  REJEITADO: "Data da rejeição",
  DEPOSITADO: "Data do depósito",
  RETIRADO: "Data da retirada",
  EXPIRADO: "Data da expiração",
};

export const STATUS_CONFIG = {
  PROCESSANDO: { label: "Processando", color: "#133660", bg: "#e8eef5" },
  CONFIRMADO: { label: "Confirmado", color: "#1f8f63", bg: "#e6f7ef" },
  DEPOSITADO: { label: "Depositado", color: "#133660", bg: "#dff8f4" },
  REJEITADO: { label: "Rejeitado", color: "#cf4d4d", bg: "#fdecec" },
  RETIRADO: { label: "Retirado", color: "#c98210", bg: "#fff3df" },
  EXPIRADO: { label: "Expirado", color: "#5f7893", bg: "#edf3f8" },
};

export const ORIGIN_CONFIG = {
  ML: { label: "Mercado Livre", color: "#ffe600", textColor: "#333" },
  SHOPEE: { label: "Shopee", color: "#ff6a2b", textColor: "#fff" },
  OUTROS: { label: "Outros", color: "#ffb000", textColor: "#1d1d1d" },
  CORREIOS: { label: "Correios", color: "#76cde8", textColor: "#133660" },
};

export const FLOW_TYPE_LABELS = {
  ENVIO: "Envio",
  DEVOLUCAO: "Devolução",
};

export const CARRIER_LABELS = {
  LOGGI: "Loggi",
  JADLOG: "JadLog",
  JT: "J&T",
  TOTALEXPRESS: "TotalExpress",
  IMILE: "Imile",
  ANJUN: "Anjun",
  PEGAKI: "Pegaki",
  MELHORPONTO: "MelhorPonto",
};

// Transportadora da lista ou, na opção "Outros" do app, o nome digitado.
export function formatCarrier(reserva) {
  if (!reserva) return "";
  if (reserva.carrier) return CARRIER_LABELS[reserva.carrier] || reserva.carrier;
  return reserva.carrierOther || "";
}

export const IMAGE_TYPE_LABELS = {
  PACKAGE_PHOTO: "Foto do pacote",
  LABEL_PHOTO: "Foto da etiqueta",
  QR_IMAGE: "Imagem do QR Code",
};
